import { Container, Row, Col, Button } from 'react-bootstrap';
import logo from '../assets/images/logo.png';
import { Link } from 'react-router-dom';

const IntroSection = () => {
    return (
        <div className="intro-section-bg">
            <Container className="py-5">
                <Row className="justify-content-center text-center">
                    {/* Kolom Kiri */}
                    <Col md={10} lg={8}>
                        <div className='mb-5'>
                            <div className="d-flex align-items-center justify-content-center mb-4 gap-3">
                                <img src={logo} alt="Logo" className="intro-logo" />
                                <h3 className="logo-text ms-3" id='logotxt1'>Syailendra Auction</h3>
                            </div>
                            <h2 className="intro-title">Welcome to Syailendra Auction</h2>
                            <p className="intro-text">
                            "Dengan kepemimpinan seorang juru lelang berpengalaman dan manajemen yang kuat, 
                            kami telah memantapkan diri sebagai balai lelang numismatik terpercaya di Indonesia. Kami menyediakan platform yang solid 
                            bagi para kolektor untuk bertransaksi uang kertas dan koin bernilai tinggi."
                            </p>
                            <Button as={Link} to={"/about"} variant="warning" className="intro-button me-2">ABOUT US</Button>
                            <Button as={Link} to={"/contact"}variant="warning" className="intro-button">CONTACT US</Button>
                        </div>
                        <div>
                            <div className="consign-box">
                                <div className="consign-inner-box">
                                    <h3>Have an Item for Sale?</h3>
                                    <p>If you have an item that you think might be of interest for us, please send it over for a free evaluation.</p>
                                    <Button as={Link} to="/selling" variant="warning" className="consign-button">
                                    CONSIGN AN ITEM &rarr;
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default IntroSection;